let _progressIntervalId;

const FJProgressUtil = {
    /**
     * @desc 开始进度
     * @param {number} startTIme
     * @param {number} endTime
     * @param {Function} callback
     */
    startProgress: (startTIme, endTime, callback) => {
        let requestAnimationTime;
        const __addProgress = timestamp => {
            if (!requestAnimationTime) requestAnimationTime = timestamp;

            const progress = Math.min((timestamp - requestAnimationTime) / 1000 + startTIme, endTime);
            callback(Math.min((progress / endTime) * 100, 99));

            if (progress >= endTime) {
                window.cancelAnimationFrame(_progressIntervalId);
                return;
            } else {
                if (_progressIntervalId) {
                    _progressIntervalId = window.requestAnimationFrame(__addProgress);
                }
            }
        };

        if (_progressIntervalId) window.cancelAnimationFrame(_progressIntervalId);
        _progressIntervalId = window.requestAnimationFrame(__addProgress);
    },

    /**
     * @desc 结束进度
     * @param {number} progress
     * @returns {number}
     */
    endProgress: () => {
        if (_progressIntervalId) window.cancelAnimationFrame(_progressIntervalId);
        _progressIntervalId = null;
    },
};

export default FJProgressUtil;
